"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
const Tab_1 = __importDefault(require("@material-ui/core/Tab"));
/**
 * Displays a row of horizontal tabs.
 */
const HorizontalTabs = ({ links }) => {
    if (!(links && links.length)) {
        return react_1.default.createElement("div", null);
    }
    let selectedIndex = links.findIndex((link) => link.isActive);
    return (react_1.default.createElement("div", { className: "bob-2 bo-gray2 w-100% pt-5" },
        react_1.default.createElement(Tabs_1.default, { value: selectedIndex >= 0 ? selectedIndex : false }, links.map(({ href, isActive, onClick, title }, index) => {
            return react_1.default.createElement(Tab_1.default, { key: index, href: href || '#', onClick: onClick, label: title });
        }))));
};
exports.default = HorizontalTabs;
